const endpoints = {
  getBasket: {
    mock: 'basket',
    live: 'basket/GetBasketForMember',
  },
  removeFromBasket: {
    mock: 'basket',
    live: 'basket/RemoveItemFromBasketMember',
  },
  removeAllFromBasket: {
    mock: 'basket',
    live: 'basket/RemoveAllItemsFromBasketMember',
  },
  addToBasket: {
    mock: 'basket',
    live: 'basket/AddToBasket',
  },
  addToBasketMultiple: {
    mock: 'basket',
    live: 'basket/AddToBasket_Multiple',
  },
  updateBasketQuantity: {
    mock: 'basket',
    live: 'basket/UpdateBasketItemQuantity',
  },
  updateSellingUnit: {
    mock: 'selling-units',
    live: 'basket/UpdateBasketItemSellingUnit',
  },
  myOrders: {
    mock: 'my-orders',
    live: 'productsearch/GetMyOrders',
  },
  myInvoicesAndCredits: {
    mock: 'my-invoices',
    live: 'productsearch/GetMyInvoicesAndCredits',
  },
  product: {
    mock: 'product',
    live: 'product',
  },
  productFilters: {
    mock: 'product-filters',
    live: 'productsearch/getproducts',
  },
  productSeasonal: {
    mock: 'product-filters-seasonal',
    live: 'productsearch/GetPurchasedThisTimeLastYear',
  },
  myProductFilters: {
    mock: 'my-products',
    live: 'productsearch/getmyproducts',
  },
  search: {
    mock: 'search',
    live: 'sitesearch/search',
  },
  addAddress: {
    mock: 'address',
    live: 'address/AddDeliveryAddress',
  },
  productSearch: {
    mock: 'product-search',
    live: 'product-search',
  },
  news: {
    mock: 'news',
    live: 'news',
  },
};

export type EndPointKeys = keyof typeof endpoints;

export const getApi = (route?: EndPointKeys) => {
  let host = 'http://localhost:3000/api';
  const endpoint = '';
  let environment = 'mock';

  const { hostname } = window.location;

  switch (hostname) {
    case 'fargro.netlify.app':
      host = 'https://fargro.netlify.app/.netlify/functions';
      environment = 'mock';
      break;
    case 'localhost':
      host = 'http://localhost:3000/api';
      environment = 'mock';
      break;
    case 'fargro.local':
      host = 'http://fargro.local/umbraco/api';
      environment = 'live';
      break;
    case 'uat.fargro.co.uk':
      host = 'https://uat.fargro.co.uk/umbraco/api';
      environment = 'live';
      break;
    case 'uat.fargro.coldbanana.tech':
      host = 'https://uat.fargro.coldbanana.tech/umbraco/api';
      environment = 'live';
      break;
    case 'live.fargro.coldbanana.tech':
      host = 'https://live.fargro.coldbanana.tech/umbraco/api';
      environment = 'live';
      break;
    case 'www.fargro.co.uk':
      host = 'https://www.fargro.co.uk/umbraco/api';
      environment = 'live';
      break;
    default:
      host = 'https://fargro.co.uk/umbraco/api';
      environment = 'live';
  }

  return `${host}/${endpoints[route][environment] || ''}`;
};

// console.log('host', process.env.API_HOST);
// console.log('React host', process.env.REACT_API_HOST);
// console.log(process.env);
